import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Avatar } from './Avatar.js';
import styles from '../routes/pageStyles.module.css';

/**
 * 사람 줄 — 검색 결과에서도, 팔로우 목록에서도 같은 모양으로 쓴다.
 *
 * 한 군데서만 쓰던 것을 꺼내 둔 이유: 찾은 사람과 이어진 사람이 다르게
 * 생기면 같은 사람인지 알아보는 데 시간이 걸린다.
 */
export function PersonList({ children }: { children: ReactNode }) {
  return <ul className={styles.personList}>{children}</ul>;
}

export function PersonRow({
  person,
  action,
  note,
}: {
  person: { handle: string; userName: string; imageUrl?: string };
  action?: ReactNode;
  note?: string | undefined;
}) {
  return (
    <li className={styles.personRow}>
      <Link to={`/@${person.handle}`} className={styles.personLink}>
        <Avatar name={person.userName} imageUrl={person.imageUrl} size={40} />
        <span className={styles.personText}>
          <strong className={styles.personName}>{person.userName}</strong>
          <span className={styles.personHandle}>
            @{person.handle}
            {note === undefined ? '' : ` · ${note}`}
          </span>
        </span>
      </Link>
      {action === undefined ? null : <span className={styles.personAction}>{action}</span>}
    </li>
  );
}
